import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import lightbulb from "assets/images/tw/lightbulb.png";
import GuessedWord from "./GuessedWord";
import {
  bounce_right_to_left_variants_entry,
  fade_bounce_delay_variants
} from "shared/components/animations";

const TWWaitingScreen = ({ guessWord, image, joke, description }) => {
  return (
    <div className="judging-fact">
      <GuessedWord image={image} word={guessWord} />

      <div className="tw-clues">
        <div className="word-entry">
          <div className="one">
            <motion.h2
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={fade_bounce_delay_variants}
              className="waiting-others"
            >
              {description}
            </motion.h2>
            <motion.div
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={bounce_right_to_left_variants_entry}
              className="rules"
            >
              <motion.div
                className="fun-fact"
                variants={fade_bounce_delay_variants}
              >
                <img src={lightbulb} alt="lightbulb" />
                <h2 className="heading">Fun Fact</h2>
              </motion.div>
              <motion.h3
                variants={fade_bounce_delay_variants}
                className="fact-did-you-know"
              >
                Did you know?{" "}
              </motion.h3>
              <motion.p
                variants={fade_bounce_delay_variants}
                className="fact-text"
              >
                {joke !== ""
                  ? joke
                  : `"Patience is not an ability to wait, but the ability to keep a good
            attitude while waiting." -Annoying Person`}
              </motion.p>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TWWaitingScreen;
